import type {
  ProcessPromptMutation,
  ProcessPromptMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const PROCESS_PROMPT: TypedDocumentNode<
  ProcessPromptMutation,
  ProcessPromptMutationVariables
> = gql`
  mutation ProcessPrompt($input: ProcessPromptInput!) {
    processPrompt(input: $input) {
      success
      message
      response
      error
    }
  }
`;
